// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"partner_m-1600__XrFn0","container":"partner_container__7_hHr","imgList":"partner_imgList__U0v8x"};